const baseLink = 'https://www.ncbi.nlm.nih.gov/';
const baseLinkDDA = 'http://linkedlifedata.com/resource/umls/id/';

export default function diseaseBaseLink(diseaseIdentifier) {
  let link = `${baseLink}medgen/${diseaseIdentifier}`;

  return link;
}
